import Vue from 'vue'
import Vuex from 'vuex'
import createVuexAlong from 'vuex-along'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createVuexAlong()],//解决刷新失效问题
  state: {
    userinfo: null,
    selectid:null,
    reload:false,
    diclist:{
      group_list:[],//分组列表
      warehouse_list:[],//仓库列表
    },
    sustain:null
  },
  getters: {
    getSustain (state) {
      return state.sustain
    },
    getDic (state) {
      return state.diclist
    },
    getReload (state) {
      return state.reload
    },
    getSelectid (state) {
      return state.selectid
    },
    getUser (state) {
      return state.userinfo
    }
  },
  mutations: {
    updateSustain (state, data) {
      state.sustain = data
    },
    updateDiclist (state, data) {
      state.diclist[data.name] = data.list
    },
    updateReload (state, data) {
      state.reload = data
    },
    updateSelectid (state, data) {
      state.selectid = data
    },
    updateUser (state, data) {
      state.userinfo = data
    },
    deleteUser (state) {
      state.userinfo = null
      state.selectid = null
      state.reload = false
      state.diclist={}
    }
  },
  actions: {
    updateSustain (context, data) {
      context.commit('updateSustain', data)
    },
    updateDiclist (context, data) {
      context.commit('updateDiclist', data)
    },
    updateSelectid (context, data) {
      context.commit('updateSelectid', data)
    },
    updateReload (context, data) {
      context.commit('updateReload', data)
    },
    updateUser (context, data) {
      context.commit('updateUser', data)
    },
    deleteUser (context) {
      context.commit('deleteUser')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js